import { t } from "@lingui/macro";

import { i18n } from "base/i18n";

import { IMAGE_FILE_EXTENSION } from "./picker.constants";
import { CONSTANT } from "./error.message";

export class FileValidation {
  constructor(config, file) {
    this.config = config;
    this.file = file;
    this.validate = this.validate.bind(this);
  }

  sizeCheck() {
    if (this.file.size) {
      return (
        this.file.size >= this.config.minSize &&
        this.file.size <= this.config.maxSize
      );
    }
    return true;
  }

  fileExtensionCheck() {
    return (
      this.config.fileExtensions.includes("*") ||
      this.config.fileExtensions.includes(this.file.fileExtension.toUpperCase())
    );
  }

  fileMaxCountCheck() {
    return this.config.validSelectedFile.length < this.config.maxCount;
  }

  imageDimensions() {
    try {
      if (this.isImage()) {
        if (this.file.height && this.file.width) {
          if (
            this.config.minHeight &&
            !(this.file.height >= this.config.minHeight)
          ) {
            throw Error("Small image");
          } else if (
            this.config.maxHeight &&
            !(this.file.height <= this.config.maxHeight)
          ) {
            throw Error("Large image");
          } else if (
            this.config.minWidth &&
            !(this.file.width >= this.config.minWidth)
          ) {
            throw Error("Small image");
          } else if (
            this.config.maxWidth &&
            !(this.file.width <= this.config.maxWidth)
          ) {
            throw Error("Large image");
          } else {
            return true;
          }
        }
      }
    } catch (err) {
      return false;
    }
    return true;
  }

  isImage() {
    return IMAGE_FILE_EXTENSION.includes(this.file.fileExtension);
  }
  validate() {
    let sizeError = CONSTANT.SIZE_ERROR;
    let invalidFileErr = CONSTANT.INVALID_FILE_ERROR;
    let maxFileErr = CONSTANT.MAX_FILE_ERROR;
    if (!this.sizeCheck()) {
      if (this.config.maxSize) {
        let maxSize = this.config.maxSize / (1024 * 1024);
        let sizeName = "KB";
        //if maxSize greater then 1 MB show limit value as MB
        if (maxSize >= 1) {
          //update the sizeName to MB
          sizeName = "MB";
        } else {
          //if maxSize less then 1 mb show limit value as KB
          maxSize = this.config.maxSize / 1024;
        }
        return i18n._(
          t`Upload failed as the file size exceeds the limit of ${Math.round(
            maxSize
          )}${sizeName}.`
        );
      }
      return sizeError;
    } else if (!this.fileExtensionCheck()) {
      return invalidFileErr;
    } else if (!this.fileMaxCountCheck()) {
      return maxFileErr;
    }
    return true;
  }

  isValid() {
    return this.sizeCheck() && this.fileExtensionCheck();
  }
}
